import { useClientTable } from "../../components/table/tableFeatures";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { Table } from "../../components/table/Table";
import { useAuditLogs } from "./api/useAuditLogs";
import { createColumnBuilder } from "../../components/table/columnBuilder";
// oxlint-disable-next-line eslint/no-redeclare -- baseline on new rule introduction
import type { AuditLog } from "../../zodios/apiDefinitions/api/auditLogs";
import moment from "moment";
import { css } from "../../../styled-system/css";
import { VStack } from "../../../styled-system/jsx";
import { TextAreaField } from "../../components/fields/base/TextAreaField";

const columnHelper = createColumnBuilder<AuditLog>();

interface Props {
  entity: string;
  ids: string[] | number[];
}

export function AuditLog({ entity, ids }: Props) {
  const { t } = useTranslation(["audit_logs"]);

  const auditLogsQuery = useAuditLogs({
    entity,
    ids,
  });

  const columns = useMemo(
    () => [
      columnHelper.accessor("timestamp", {
        header: () => t(($) => $.audit_logs.columns["Timestamp"]),
        cell: (info) => moment(info.getValue()).format("YYYY-MM-DD HH:mm:ss"),
      }),
      columnHelper.accessor("ref_id", {
        header: () => t(($) => $.audit_logs.columns["Campaign ID"]),
      }),
      columnHelper.accessor("action", {
        header: () => t(($) => $.audit_logs.columns["Action"]),
      }),
      columnHelper.accessor("payload", {
        header: () => t(($) => $.audit_logs.columns["Payload"]),
        cell: function Cell(info) {
          return (
            <VStack alignItems="start" width="100%">
              <TextAreaField
                className={css({ width: "100%", height: "100px" })}
                value={JSON.stringify(info.getValue(), null, 2)}
                isReadOnly
              />
            </VStack>
          );
        },
        size: 250,
      }),
    ],
    [t],
  );

  const table = useClientTable({
    data: auditLogsQuery.data,
    columns,
  });

  return <Table table={table} />;
}
